import React from 'react';
import { FaUser, FaCode, FaRocket, FaHeart } from 'react-icons/fa';
import './About.css';

const About = () => {
  const highlights = [
    {
      icon: <FaCode />,
      title: "Full-Stack Development",
      description: "Proficient in both frontend and backend technologies with expertise in modern frameworks."
    },
    {
      icon: <FaRocket />,
      title: "Scalable Solutions",
      description: "Experience in building robust, scalable applications that handle real-world challenges."
    },
    {
      icon: <FaHeart />,
      title: "User-Centric Design",
      description: "Passionate about creating intuitive user experiences that delight and engage users."
    }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        
        <div className="about-content">
          <div className="about-text">
            <div className="about-intro">
              <FaUser className="intro-icon" />
              <h3>Who I Am</h3>
            </div>
            
            <p className="about-description">
              I'm a passionate Full-Stack Software Engineer with over 3+ years of experience in developing
              innovative web and mobile applications. My journey in technology began with a curiosity to
              understand how digital solutions can solve real-world problems, and it has evolved into a
              professional pursuit of excellence in software development.
            </p>
            
            <p className="about-description">
              Currently working at Xorlabs Pvt.Ltd, I specialize in JavaScript, React, Next.js, Node.js, 
              and MongoDB. I have a proven track record of delivering high-quality, user-centric solutions 
              in agile environments, with a particular focus on healthcare technology and community-driven applications.
            </p>
            
            <p className="about-description">
              When I'm not coding, you'll find me exploring new technologies, contributing to open-source projects, 
              or mentoring junior developers. I believe in continuous learning and staying updated with the latest 
              industry trends to deliver cutting-edge solutions.
            </p>
          </div>
          
          <div className="about-highlights">
            {highlights.map((highlight, index) => (
              <div key={index} className="highlight-item">
                <div className="highlight-icon">
                  {highlight.icon}
                </div>
                <div className="highlight-content">
                  <h4>{highlight.title}</h4>
                  <p>{highlight.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="about-stats">
          <div className="stat-card">
              <div className="stat-number">3+</div>
            <div className="stat-label">Years of Experience</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">15+</div>
            <div className="stat-label">Technologies Proficient</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">2+</div>
            <div className="stat-label">Projects Delivered (Major)</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">100%</div>
            <div className="stat-label">Client Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
